import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HotMoviesSection() {
  const hotMovies = movies.filter((m) => m.trending).slice(0, 8);

  return (
    <section className="py-12 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的热门影视</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}

function MovieCard({ movie }: { movie: typeof movies[0] }) {
  return (
    <Link
      to={`/article/${movie.slug}`}
      className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} - 星空影院${movie.quality}高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-background-950 dark:text-foreground-950 text-xs font-semibold rounded-md whitespace-nowrap">
          {movie.rating}
        </div>
        <div className="absolute top-2 left-2 px-2 py-0.5 bg-background-950/70 backdrop-blur-sm text-foreground-100 text-xs rounded-md whitespace-nowrap">
          {movie.quality}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
          <span className="px-5 py-2 bg-primary-500 text-background-950 dark:text-foreground-950 text-sm font-semibold rounded-full whitespace-nowrap">
            <i className="ri-play-fill mr-1"></i>立即播放
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500 flex-wrap">
          <span>{movie.year}</span>
          <span className="text-foreground-700">·</span>
          <span>{movie.category}</span>
          <span className="text-foreground-700">·</span>
          <span>{movie.duration}</span>
        </div>
      </div>
    </Link>
  );
}